import { useMutation } from '@gogame/query';

import ShareAccounts, {
  LOOKALIKE_AUDIENCE,
} from 'scenes/CustomAudiences/LookalikeAudiences/components/ShareAccounts';
import { createSharedAccountLookalikeAudience } from 'scenes/CustomAudiences/LookalikeAudiences/sources/sharedAccounts';

import { share } from '../queryKeyFactory';

export const useShareLookalikeAudience = ({ showModal }) => {
  const shareMutation = useMutation(
    share(),
    createSharedAccountLookalikeAudience,
    {
      successMessage: () => `Lookalike Audience shared`,
    }
  );

  const handleAction = async ({ id: lookalikeAudience }) => {
    const values = await new Promise((resolve, reject) => {
      showModal(ShareAccounts, {
        initialValues: {
          [LOOKALIKE_AUDIENCE]: lookalikeAudience,
        },
        onSubmit: resolve,
        onClose: reject,
      });
    });

    await shareMutation.mutateAsync(values);
  };

  return [handleAction, shareMutation];
};
